var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('body',[_c('div',{staticClass:"error-main"},[_c('h1',[_vm._v("Oops!")]),_c('div',{staticClass:"error-heading"},[_vm._v("403")]),_c('p',[_vm._v("You do not have permission to access the document or program that you requested.")])])])
}]

export { render, staticRenderFns }